import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'
import Restaurantdetail from '../components/Restaurant/Restaurantdetail'
import Restaurantheader from '../components/Restaurant/Restaurantheader'
import Restaurantphotos from '../components/Restaurant/Restaurantphotos'
import { metadata as restaurantContent } from '../mdx/services/Restaurant/restaurant.mdx'

const Restaurantpage = () => {
    return (
        <div>
        <Navbar/>
        <Restaurantheader content={restaurantContent}/>
        <Restaurantdetail/>
        <Restaurantphotos/>
        <Footer/>

        </div>
    )
}

export default Restaurantpage
